import React, { useState, useEffect, useContext, Component } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import Header from '../components/Header'
import Footer from '../components/Footer';
import axiosInstance from '../../axiosInstance';
import LoadingScreen from '../components/LoadingScreen';

const Blog = () => {

  const [blog, setBlog] = useState({});
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [Rblogs, setRBlogs] = useState([]);

  const getBlog = async () => {
    setIsLoading(true);
    try {
      const { data } = await axiosInstance.get(`/get-blog/${slug}`);
      setBlog(data.blog);

      // Delay the execution of buildScript by 1 secon

    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    }finally{
      setIsLoading(false);
    }
  };

  const getAllBlogs = async () => {
    // try {
    //   setIsLoading(false);
    //   const response = await axiosInstance.get('/all-blogs');
    //   const { success, blogs, message } = response.data;
    //   console.log(response.data)
    //   if (success) {
    //     setRBlogs(blogs.reverse().slice(0, 8))
    //   } else {
    //     console.error('Error fetching blogs:', message);
    //   }
    // } catch (error) {
    //   console.error('Error fetching blogs:', error);
    // } finally {
    //   setIsLoading(true);
    // }

  };


  useEffect(() => {
    getBlog();
    getAllBlogs();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render

  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }


  return (
    <>
      <Header />
      <Helmet>
        <title>{blog.metaTitle}</title>
        <meta name="metaDescription" content={blog.title} />

      </Helmet>



      <main className="page whitesmoke">
        {/* Header */}
        {/* Header */}
        {/* Blog Title */}
        <div className="py-4" >
          <div className="container d-lg-flex justify-content-between align-items-center py-2">
            <div className="pe-lg-4 text-center text-lg-start">
              <h1 className="h3 mb-0"> {blog.title} </h1>
            </div>
            <div className="pt-2 pt-lg-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-start">
                  <li className="breadcrumb-item">
                    <Link
                      className="text-nowrap"
                      to="/"
                      previewlistener="true"
                    >
                      <i className="ri-store-2-line" /> Home{" "}
                    </Link>
                  </li>


                  <li className="breadcrumb-item  text-nowrap">
                    <Link
                      className="text-nowrap"
                      to="/allblogs"
                      previewlistener="true"
                    >
                      All Blogs
                    </Link>
                  </li>


                </ol>
              </nav>
            </div>
          </div>
        </div>
        {/* Blog Title */}
        {/* Blog List */}
        <div className="container pb-4" style={{minHeight:'80vh'}}>
        
            {isLoading ?
     <LoadingScreen/>
                  
                    :
         
              <div dangerouslySetInnerHTML={{ __html: blog.description }} />

  
            }
             
        
        </div>
        {/* Blog List*/}
      </main >
 

  

      <Footer />
    </>

  )
}

export default Blog